<template>
  <v-list-item @click="logout">
    <v-list-item-title>
      Kilépés
      <form ref="logout" :method="method" :action="route">
        <CsrfToken />
      </form>
    </v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: "Logout",
  props: {
    method: {
      type: String,
      default: "POST",
      required: false
    },
    route: {
      type: String,
      default: "/logout",
      required: false
    }
  },
  methods: {
    logout() {
      this.$refs.logout.submit();
    }
  }
};
</script>

<style></style>
